// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as SupSection from "./SupSection.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

function SupCharms$Charm(Props) {
  var name = Props.name;
  var desc = Props.desc;
  var cost = Props.cost;
  Translation.useT(/* Augments */4);
  var basePath3 = CdnAtom.usePath4(undefined);
  return React.createElement(ContentSection.make, {
              className: "pt-3 pb-2",
              children: null
            }, React.createElement("div", {
                  className: "flex justify-between items-center gap-2 pb-2"
                }, React.createElement("div", {
                      className: "font-montserrat font-medium py-1"
                    }, name), React.createElement("div", {
                      className: "flex items-end text-[16px] font-montserrat font-semibold"
                    }, String(cost), React.createElement("img", {
                          className: "ml-[2px] pb-[1px]",
                          alt: "gold",
                          height: "13",
                          src: basePath3 + "/general/gold.png?width=13",
                          width: "13"
                        }))), React.createElement(RitoDescription2.make, {
                  desc: desc,
                  className: "text-sm leading-tight"
                }));
}

var Charm = {
  make: SupCharms$Charm
};

function SupCharms$CharmsGroup(Props) {
  var charms = Props.charms;
  var tier = Props.tier;
  var charms$1 = Belt_SortArray.stableSortBy(charms, (function (c1, c2) {
          var g1 = c1.cost;
          var g2 = c2.cost;
          var gc = Caml.caml_int_compare(g1, g2);
          if (gc === 0) {
            return Caml.caml_string_compare(c1.name, c2.name);
          } else {
            return gc;
          }
        }));
  var label;
  if (tier !== 25) {
    if (tier >= 10) {
      label = tier !== 99 ? "" : "Xerath's Ascendant Charms";
    } else if (tier > 0) {
      switch (tier) {
        case 1 :
            label = "Tier 1 (Stage 2-3)";
            break;
        case 2 :
            label = "Tier 2 (Stage 3-4)";
            break;
        case 3 :
            label = "Tier 3 (Stage 4+)";
            break;
        case 4 :
            label = "Tier 4 (Stage 5+)";
            break;
        case 5 :
        case 6 :
        case 7 :
        case 8 :
            label = "";
            break;
        case 9 :
            label = "Tier 4+ (Stage 7+)";
            break;
        
      }
    } else {
      label = "";
    }
  } else {
    label = "Tier 2.5 (Stage 3-5)";
  }
  return React.createElement(React.Fragment, undefined, React.createElement("h3", {
                  className: "text-xl font-montserrat font-medium border-b border-secondary-11 pt-8 mb-5"
                }, label), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
                }, Belt_Array.map(charms$1, (function (charm) {
                        return React.createElement(SupCharms$Charm, {
                                    name: charm.name,
                                    desc: charm.desc,
                                    cost: charm.cost,
                                    key: charm.id
                                  });
                      }))));
}

var CharmsGroup = {
  make: SupCharms$CharmsGroup
};

function SupCharms(Props) {
  var charms = Props.charms;
  var t = Translation.useT(/* Common */0);
  TftSet.use(undefined);
  return React.createElement(SupSection.make, {
              children: null,
              id: "set-update-charms",
              title: t("Charms")
            }, React.createElement(SupCharms$CharmsGroup, {
                  charms: Belt_Array.keep(charms, (function (charm) {
                          return charm.tier === "1";
                        })),
                  tier: 1
                }), React.createElement(SupCharms$CharmsGroup, {
                  charms: Belt_Array.keep(charms, (function (charm) {
                          return charm.tier === "2";
                        })),
                  tier: 2
                }), React.createElement(SupCharms$CharmsGroup, {
                  charms: Belt_Array.keep(charms, (function (charm) {
                          return charm.tier === "2_5";
                        })),
                  tier: 25
                }), React.createElement(SupCharms$CharmsGroup, {
                  charms: Belt_Array.keep(charms, (function (charm) {
                          return charm.tier === "3";
                        })),
                  tier: 3
                }), React.createElement(SupCharms$CharmsGroup, {
                  charms: Belt_Array.keep(charms, (function (charm) {
                          return charm.tier === "4";
                        })),
                  tier: 4
                }), React.createElement(SupCharms$CharmsGroup, {
                  charms: Belt_Array.keep(charms, (function (charm) {
                          return charm.tier === "9";
                        })),
                  tier: 9
                }), React.createElement(SupCharms$CharmsGroup, {
                  charms: Belt_Array.keep(charms, (function (charm) {
                          return charm.tier === "99";
                        })),
                  tier: 99
                }));
}

var make = SupCharms;

export {
  Charm ,
  CharmsGroup ,
  make ,
  
}
/* react Not a pure module */
